import styled from 'styled-components';

export const Container = styled.div`
  display: flex;

  @media (max-width: 900px) {
    flex-direction: column;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
  padding: 2rem 0;
  width: 100%;
  background: ${({ theme }) => theme.colors.background_white};

  .page-title {
    display: flex;
    width: 100%;
    justify-content: start;
  }

  /* .container {
    display: flex;
    justify-content: center;
    width: 100%;
    max-width: 100rem;
    max-width: 90rem;
    background: ${({ theme }) => theme.colors.background};
  } */
  .contentButton {
    width: 85%;
    display: flex;
    justify-content: flex-end;
  }

  @media (max-width: 900px) {
    padding: 0;
  }
`;
